function initializeRichpanelLiveChat() {
    var NUMBER_OF_TIMES_TRIED = 0;

    function openRichpanelWidget() {
        if (window.RichpanelAppProxy) {
            window.RichpanelAppProxy.showMessenger();
        } else {
            if (NUMBER_OF_TIMES_TRIED < 20) {
                startLookingForRichpanelLiveChat();
            }
        }
    }

    function startLookingForRichpanelLiveChat() {
        NUMBER_OF_TIMES_TRIED = NUMBER_OF_TIMES_TRIED+1;
        setTimeout(openRichpanelWidget, 1000)
    }

    openRichpanelWidget();
}

(() => {

    const elements = document.querySelectorAll('[data-open-richpanel]');

    elements.forEach(element => {
        element.addEventListener('click', () => {
            initializeRichpanelLiveChat();
        });
    });

})();
